import { Component, createRef, Fragment } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import update from 'immutability-helper';

import { animateFixedMoveTo, animateScrollTo } from 'Lib/utilities/animate';

import { FullScreenModal, FullScreenModalBody, FullScreenModalFooter, FullScreenModalHeader } from '../../../../modals/FullScreenModal';

import { PreviewProvider } from './Context';
import Field from './Field';
import Page from './Page';

import './styles.scss';

const DESKTOP_WIDTH = 860;
const TABLET_WIDTH = 400;
const SIDEBAR_SIZE = 105;

const calcFieldKey = (pageIndex, fieldIndex) => {
    return `${pageIndex}_${fieldIndex}`;
};

const parseFieldKey = key => {
    const parts = key.split('_');

    return {
        pageIndex: parseInt(parts[0]),
        fieldIndex: parseInt(parts[1])
    };
};

class Addendum extends Component {
    state = {
        selectedZoom: -1,
        isInitialized: false,
        isParsed: false,
        isComplete: false,
        zoomFactor: 1,
        navOffset: null,
        signature: null,
        nav: {
            isStarted: false,
            isFocused: false,
            isComplete: false,
            isVisible: true
        }
    };

    pages = {};

    inputs = [];

    inputMap = {};

    currentInput = -1;

    isScrolling = false;

    constructor(props) {
        super(props);

        // if(window.innerWidth >= DESKTOP_WIDTH){
        // 	this.state.selectedZoom = 100;
        // }else{
        // 	this.state.selectedZoom = -1;
        // }

        this.state.selectedZoom = -1;

        this.topRef = createRef();
        this.centerRef = createRef();
        this.centerLineRef = createRef();

        this.navRef = createRef();
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);
        this.parseEnvelope();
    }

    componentDidUpdate(prevProps) {
        // if(prevProps.envelope?.timestamp != this.props.envelope?.timestamp){
        // }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);

        if (this.scrollWrapper && this.scrollWrapper.removeEventListener) {
            this.scrollWrapper.removeEventListener('scroll', this.onScroll);
        }
    }

    onWindowResize = () => {
        if (!this.scrollWrapper) {
            return;
        }

        let zoom = this.state.selectedZoom;
        zoom = -1;

        // if(window.innerWidth < DESKTOP_WIDTH){
        // 	zoom = -1;
        // }else{
        // 	zoom = 100;
        // }

        const bounds = this.scrollWrapper.getBoundingClientRect();

        this.setWorkspaceWidth(bounds.width, false, zoom);
    };

    parseEnvelope = () => {
        const availableFieldMap = {};
        let maxWidth = 0;

        this.props.envelope.availableFields.forEach((availableField, availableFieldIndex) => {
            availableFieldMap[availableField.name] = availableFieldIndex;
        });

        this.props.envelope.pages.forEach(page => {
            if (page.width > maxWidth) {
                maxWidth = page.width;
            }
        });

        const newState = {
            envelope: this.props.envelope,
            isParsed: true,
            availableFieldMap,
            maxWidth,
            inputs: {},
            currentInput: {
                pageIndex: -1,
                fieldIndex: -1
            }
        };

        this.setState(newState);
    };

    createContext = () => {
        return {
            state: this.state,
            getAvailableFieldByName: this.getAvailableFieldByName,
            addInputFieldElement: this.addInputFieldElement,
            setPageElement: this.setPageElement,
            setCurrentInput: this.setCurrentInput,
            getFieldInputValue: this.getFieldInputValue,
            setFieldInputValue: this.setFieldInputValue
        };
    };

    /**
     * Get the available field via the name.
     *
     * @param {Name of the field.} name
     */
    getAvailableFieldByName = name => {
        const availableFieldIndex = this.state.availableFieldMap[name];

        if (!(availableFieldIndex >= 0)) {
            throw 'Available Field not found';
        }

        return this.state.envelope.availableFields[availableFieldIndex];
    };

    /**
     * Register the page's html container
     * @param {Page Index} pageIndex
     * @param {HTML Element} element
     */
    setPageElement = (pageIndex, element) => {
        this.pages[pageIndex] = element;
    };

    /**
     * Register an Input's HTML Element container
     * @param {Page Index} pageIndex
     * @param {Field Index} fieldIndex
     * @param {HTML Element} element
     */
    addInputFieldElement = (pageIndex, fieldIndex, element) => {
        const key = calcFieldKey(pageIndex, fieldIndex);
        let replaceIndex = -1;

        if (this.inputMap[key] >= 0) {
            replaceIndex = this.inputMap[key];
        }

        const compare = (field1, field2) => {
            if (field1.pageIndex < field2.pageIndex) {
                return -1;
            } else if (field1.pageIndex > field2.pageIndex) {
                return 1;
            } else {
                const fieldInfo1 = this.state.envelope.pages[field1.pageIndex].fields[field1.fieldIndex];
                const fieldInfo2 = this.state.envelope.pages[field2.pageIndex].fields[field2.fieldIndex];

                if (fieldInfo1.y < fieldInfo2.y) {
                    return -1;
                } else if (fieldInfo1.y > fieldInfo2.y) {
                    return 1;
                } else {
                    if (fieldInfo1.x < fieldInfo2.x) {
                        return -1;
                    } else if (fieldInfo1.x > fieldInfo2.x) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            }
        };

        const newItem = {
            pageIndex,
            fieldIndex,
            element
        };

        let newList = [...this.inputs];

        if (replaceIndex >= 0) {
            // Remove if previously in list
            newList = update(newList, {
                $splice: [[replaceIndex, 1]]
            });
        }

        let index = 0;
        for (let i = 0; i < this.inputs.length; i++) {
            const listItem = this.inputs[i];

            if (compare(listItem, newItem) >= 0) {
                break;
            } else {
                index++;
            }
        }

        newList = update(newList, {
            $splice: [[index, 0, newItem]]
        });

        const map = {};
        newList.forEach((item, itemIndex) => {
            const nKey = calcFieldKey(item.pageIndex, item.fieldIndex);
            map[nKey] = itemIndex;
        });

        this.inputMap = map;
        this.inputs = newList;
    };

    getInput = (pageIndex, fieldIndex) => {
        const key = calcFieldKey(pageIndex, fieldIndex);
        let item = null;
        if (this.inputMap[key] >= 0) {
            item = this.inputs[this.inputMap[key]];
        }
        return item;
    };

    getNextInput = (afterPageIndex = -1, afterFieldIndex = -1) => {
        let startingIndex = this.currentInput;

        if (afterPageIndex >= 0 && afterFieldIndex >= 0) {
            const possibleIndex = this.inputs.findIndex(input => {
                if (input.pageIndex == afterPageIndex && input.fieldIndex == afterFieldIndex) {
                    return true;
                }
                return false;
            });

            if (!possibleIndex >= 0) {
                startingIndex = possibleIndex;
            }
        }

        let nextInput = null;
        let item = {};
        let value = null;
        let doLoop = true;
        let index = this.currentInput + 1;

        while (doLoop) {
            if (index >= this.inputs.length) {
                index = 0;
            }

            item = this.inputs[index];
            value = this.getFieldInputValue(item?.pageIndex, item?.fieldIndex);

            if (value) {
                if (index == startingIndex) {
                    doLoop = false;
                }
                index++;
            } else {
                doLoop = false;
                nextInput = item;
                this.currentInput = index;
            }
        }

        return nextInput;
    };

    setCurrentInput = (pageIndex, fieldIndex, scrollTo = false) => {
        const newState = update(this.state, {
            currentInput: {
                pageIndex: { $set: pageIndex },
                fieldIndex: { $set: fieldIndex }
            },
            nav: {
                isFocused: { $set: true }
            }
        });

        this.setState(newState, () => {
            if (scrollTo) {
                this.scrollToInput(pageIndex, fieldIndex);
            }
        });
    };

    getFieldInputValue = (pageIndex, fieldIndex) => {
        const key = calcFieldKey(pageIndex, fieldIndex);

        if (this.state.inputs[key]) {
            return this.state.inputs[key];
        }
        return null;
    };

    setFieldInputValue = (pageIndex, fieldIndex, value, goToNext = true) => {
        if (!this.props.signature) {
            return this.props.promptSignature();
        }

        const key = calcFieldKey(pageIndex, fieldIndex);

        let newState = update(this.state, {
            inputs: {
                [key]: { $set: value }
            }
        });

        if (Object.keys(newState.inputs).length == this.inputs.length) {
            newState = update(newState, {
                isComplete: { $set: true },
                nav: {
                    isVisible: { $set: false },
                    isComplete: { $set: true }
                }
            });
        }

        this.setState(newState, () => {
            if (goToNext) {
                const nextInput = this.getNextInput(pageIndex, fieldIndex);

                if (nextInput) {
                    this.setCurrentInput(nextInput.pageIndex, nextInput.fieldIndex, true);
                }
            }
        });
    };

    /**
     * Set the workspace width.
     *
     * @param {New workspace width} width
     * @param {Indicate if the workspace has been initialized} isInit
     */
    setWorkspaceWidth = (width, isInit = false, zoom = null) => {
        if (!zoom) {
            zoom = this.state.selectedZoom;
        }

        let zoomFactor = zoom / 100;
        if (zoom == -1) {
            zoomFactor = width / this.state.maxWidth;
        }

        let newState = update(this.state, {
            workspaceWidth: { $set: width },
            zoomFactor: { $set: zoomFactor }
        });

        if (isInit) {
            newState = update(newState, {
                isInitialized: { $set: true }
            });
        }
        if (zoom) {
            newState = update(newState, {
                selectedZoom: { $set: zoom }
            });
        }

        this.setState(newState);
    };

    setScrollWrapper = element => {
        if (!element) {
            return;
        }

        if (this.scrollWrapper) {
            this.scrollWrapper.removeEventListener('scroll', this.onScroll);
        }

        const bounds = element.getBoundingClientRect();
        if (this.state.selectedZoom == -1 && bounds.width != this.state.workspaceWidth) {
            this.setWorkspaceWidth(bounds.width, true);
        } else {
            this.setState({
                isInitialized: true
            });
        }

        this.scrollWrapper = element;
        this.scrollWrapper.addEventListener('scroll', this.onScroll);
    };

    onNavClick = () => {
        this.setState(
            update(this.state, {
                nav: {
                    isStarted: { $set: true }
                }
            }),
            () => {
                if (!this.scrollWrapper) {
                    return;
                }

                const item = this.getNextInput();

                if (!item) {
                    return;
                }

                this.setCurrentInput(item.pageIndex, item.fieldIndex, true);
            }
        );
    };

    onScroll = () => {
        if (
            this.state.currentInput &&
            this.isAutoScrolling === false &&
            this.state.currentInput.pageIndex >= 0 &&
            this.state.currentInput.fieldIndex >= 0 &&
            this.state.nav.isFocused == true
        ) {
            this.setState(
                update(this.state, {
                    nav: {
                        isFocused: { $set: false }
                    }
                })
            );
        }
    };

    onSubmit = () => {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
    };

    render() {
        const { isLoading, loadingText = 'Loading Details...' } = this.props;

        const { envelope, isComplete } = this.state;

        const navStyles = {};
        const navButtonStyles = {};

        if (window.innerWidth >= DESKTOP_WIDTH) {
            navStyles.width = this.state.maxWidth ? this.state.maxWidth + SIDEBAR_SIZE * 2 : null;
        }

        if (this.state.maxWidth) {
            if (window.innerWidth > this.state.maxWidth + SIDEBAR_SIZE * 2) {
                navStyles.margin = '0 auto';
            }
        }

        if (this.state.navOffset > 0) {
            navButtonStyles.top = this.state.navOffset;
        }

        if (this.state.nav.isVisible === false) {
            navButtonStyles.display = 'none';
        }

        let currentInputField = null;
        if (this.state.envelope && this.state.currentInput && this.state.currentInput.pageIndex >= 0 && this.state.currentInput.fieldIndex >= 0) {
            const currentField = this.state.envelope.pages[this.state.currentInput.pageIndex].fields[this.state.currentInput.fieldIndex];
            if (currentField) {
                currentInputField = this.getAvailableFieldByName(currentField.name);
            }
        }

        return (
            <PreviewProvider value={this.createContext()}>
                <FullScreenModal isOpen={true} isLoading={isLoading} loadingText={loadingText}>
                    <FullScreenModalHeader title="Sign and Initial">
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div
                                style={{
                                    flexGrow: '1',
                                    justifyContent: 'right'
                                }}
                            >
                                <Button
                                    outline
                                    type="button"
                                    size="sm"
                                    onClick={() => {
                                        this.props.toggle();
                                    }}
                                >
                                    Cancel
                                </Button>
                                {'  '}
                                <Button disabled={!isComplete} type="button" size="sm" color="warning" onClick={this.onSubmit}>
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </FullScreenModalHeader>
                    <FullScreenModalBody>
                        <div className="addendum-viewer">
                            <div className="addendum-viewer-wrapper">
                                {/* <div className="addendum-viewer-toolbar-wrapper">

									</div> */}
                                <div className="addendum-viewer-panel-pages">
                                    <div className="addendum-viewer-page-scroll-wrapper" ref={this.setScrollWrapper}>
                                        <div className="addendum-viewer-navigation-container" style={navStyles}>
                                            <button
                                                className={classNames('addendum-viewer-navigation-button', { 'is-focused': this.state.nav.isFocused })}
                                                onClick={this.onNavClick}
                                                ref={this.navRef}
                                                style={navButtonStyles}
                                                tabIndex="-1"
                                            >
                                                {this.state.nav.isStarted ? (
                                                    <Fragment>
                                                        {this.state.nav.isFocused ? (
                                                            <Fragment>
                                                                {currentInputField ? <Fragment>{currentInputField.actionText}</Fragment> : <Fragment>Next</Fragment>}
                                                            </Fragment>
                                                        ) : (
                                                            <Fragment>Next</Fragment>
                                                        )}
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>Start</Fragment>
                                                )}
                                            </button>
                                            {this.state.isInitialized && this.state.isParsed ? (
                                                <Fragment>
                                                    {envelope.pages.map((page, pageIndex) => {
                                                        return (
                                                            <Fragment key={pageIndex}>
                                                                <Page
                                                                    scrollWrapper={this.scrollWrapper}
                                                                    index={pageIndex}
                                                                    signature={this.props.signature}
                                                                    form={this.props.form}
                                                                />
                                                            </Fragment>
                                                        );
                                                    })}
                                                </Fragment>
                                            ) : null}
                                        </div>
                                        <div className="addendum-viewer-complete-panel">
                                            <Button type="button" color="primary" disabled={!isComplete} onClick={this.onSubmit}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FullScreenModalBody>
                    <FullScreenModalFooter></FullScreenModalFooter>
                </FullScreenModal>
            </PreviewProvider>
        );
    }

    scrollToInput = (pageIndex, fieldIndex, callback = null) => {
        const item = this.getInput(pageIndex, fieldIndex);

        if (!item) {
            return;
        }

        const pageElement = this.pages[item.pageIndex];

        if (!pageElement) {
            return;
        }

        const yStart = this.scrollWrapper.scrollTop;
        const yEnd = yStart + this.scrollWrapper.clientHeight;
        const scrollBounds = this.scrollWrapper.getBoundingClientRect();
        const itemBounds = item.element.getBoundingClientRect();
        const itemTop = item.element.offsetTop + pageElement.offsetTop;
        const navBounds = this.navRef.current.getBoundingClientRect();
        const containerOffset = scrollBounds.top;

        let scrollTop = this.scrollWrapper.scrollTop;

        if (itemTop >= yStart && itemTop <= yEnd) {
            // Need to move button to appropriate location.
        } else {
            // Not in view
            scrollTop = scrollTop + (itemTop + 0.5 * itemBounds.height - (this.scrollWrapper.scrollTop + this.scrollWrapper.clientHeight * 0.5));
        }

        this.isAutoScrolling = true;
        // Set and reset the variable just incase the scroll top is to high

        animateScrollTo(
            0,
            scrollTop,
            this.scrollWrapper,
            () => {
                item.element.focus();
                scrollTop = this.scrollWrapper.scrollTop;
                const newNavTop = itemTop - scrollTop + containerOffset + itemBounds.height * 0.5 - navBounds.height * 0.5;

                // this.navRef.current.style.top = newNavTop + 'px';
                this.navRef.current.style.marginTop = '0px';

                animateFixedMoveTo(
                    'auto',
                    newNavTop,
                    this.navRef.current,
                    () => {
                        if (callback) {
                            callback();
                        }

                        this.isAutoScrolling = false;
                    },
                    500
                );
            },
            500
        );
    };

    // scrollTo = (y, element, duration = 200, callback = null) => {

    // 	if(element.scrollTop == y){
    // 		if(callback){
    // 			callback();
    // 		}
    // 		return;
    // 	}

    // 	let oldTimestamp = null;
    // 	let stepDistance = 0;
    // 	let totalScrollDistance = y - element.scrollTop;

    // 	//const limit = element.scrollHeight -  element.clientHeight;

    // 	const scrollDir = totalScrollDistance  >= 0 ? 'down' : 'up';
    // 	totalScrollDistance = Math.abs(totalScrollDistance);

    // 	let scrollY = element.scrollTop, stepDistance = 0, oldTimestamp = null;

    // 	const step = (newTimestamp) => {
    // 		if(oldTimestamp){
    // 			let percentComplete = (newTimestamp - oldTimestamp) / duration;

    // 			if(percentComplete > 1){
    // 				percentComplete = 1;
    // 			}

    // 			const stepFactor = this.easeInSine(percentComplete);

    // 			stepDistance = totalScrollDistance * stepFactor;

    // 			if(scrollDir == 'up'){
    // 				stepDistance *= -1;
    // 			}

    // 			element.scrollTop = scrollY + stepDistance;

    // 			if(percentComplete == 1){
    // 				if(callback){
    // 					callback();
    // 				}
    // 				return;
    // 			}
    // 		}else{
    // 			oldTimestamp = newTimestamp;
    // 		}
    // 		window.requestAnimationFrame(step);
    // 	}

    // 	window.requestAnimationFrame(step);
    // }

    moveTo = (y, element, duration = 200, callback = null) => {
        if (element.top == y) {
            if (callback) {
                callback();
            }
            return;
        }

        const bounds = element.getBoundingClientRect();

        let totalMoveDistance = y - bounds.top;

        const moveDir = totalMoveDistance >= 0 ? 'down' : 'up';

        totalMoveDistance = Math.abs(totalMoveDistance);

        const top = bounds.top;
        let stepDistance = 0;
        let oldTimestamp = null;

        const step = newTimestamp => {
            if (oldTimestamp !== null) {
                let percentComplete = (newTimestamp - oldTimestamp) / duration;

                if (percentComplete > 1) {
                    percentComplete = 1;
                }

                stepDistance = totalMoveDistance * this.easeOutSine(percentComplete);

                if (moveDir == 'up') {
                    stepDistance *= -1;
                }

                element.style.top = `${top + stepDistance}px`;

                if (percentComplete == 1) {
                    if (callback) {
                        callback();
                    }
                }
            } else {
                oldTimestamp = newTimestamp;
            }
            window.requestAnimationFrame(step);
        };

        window.requestAnimationFrame(step);
    };

    linear = percentComplete => {
        return percentComplete;
    };

    easeOutSine = percentComplete => {
        return Math.sin((percentComplete * Math.PI) / 2);
    };

    easeInSine = percentComplete => {
        return 1 - Math.cos((percentComplete * Math.PI) / 2);
    };
}

export default Addendum;
